import { useState } from 'react';
import { faqItems } from '@/mocks/faq';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="08 / 常见问题"
          title="关于《蜜桃成熟时》的常见疑问"
          desc="整理了几个观影前最常被问到的问题，点击即可展开查看答案。"
        />

        <div className="mt-8 flex flex-col gap-3">
          {faqItems.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => toggle(index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-label text-xs font-medium text-secondary-900">
                        Q
                      </span>
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${
                        open ? 'rotate-180 bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-lg" />
                    </span>
                  </button>
                </h3>
                {open ? (
                  <div className="border-t border-background-200 px-5 py-4 md:px-6">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}